import axios from "axios";
import CityService from "./../City";

export default class ZipCode {
  async findZipCode({ zipCode }) {
    try {
      const cityService = new CityService();
      const response = await axios.get(`https://viacep.com.br/ws/${zipCode}/json/`).then(response => {
        try {
          if(response.data.erro === true) {
            return {
              success: false,
              data: false
            };
          }
          return {
            success: true,
            data: response.data
          };
        } catch (error) {
          console.log(error);
          return {
            success: false,
            data: false
          }
        }
      }).catch(error => {
        try {
          if(error.response.data === "Unauthorized") {
            return {
              success: false,
              error: {
                type: "UnauthorizedError",
                details: [{
                  message: "UnauthorizedError"
                }]
              }
            };
          }
          return error.response.data;
        }
        catch(error) {
          return {
            success: false,
            error: {
              type: "NetworkError",
              details: [{
                message: "NetworkError"
              }]
            }
          };
        }
      });
      if (response && response.data && response.data.erro) return false;
      if(response.success) {
        response.data.dataAux = await cityService.findByExternalId({ externalId: response.data.ibge });
        return response.data;
      }
      return false;
    } catch (error) {
      console.log(error);
      return false;
    }
  }
}
